import {injectable, Inject} from 'inversify-props';
import HttpClient from './http-client';
import {TrackingCookie} from "@/app/services/tracking-cookie";
import {AFFILIATE_COOKIE_NAME} from "@/app/shared/common/constants";
import store from '../../store';
import AffiliateViewDataModel from '@/app/shared/models/affiliate-view-data.model';

@injectable()
export class AffiliateConfigurationService {
    @Inject() httpClient: HttpClient;

    constructor() {
    }

    public getConfiguration() {
        return this.httpClient.get('/affiliate-configuration');
    }

    public getAffiliateSettings(userId: number) {
        return this.httpClient.get('/affiliate-settings/' + userId);
    }

    public saveConfiguration(configuration: any) {
        let formData = new FormData();
        formData.append('logo', configuration.logo);
        for(let i in configuration){
            if(i !== 'logo'){
                formData.append(i, JSON.stringify(configuration[i]));
            }
        }

        return this.httpClient.post('/affiliate-configuration', formData, true);
    }

    public setFromCookie(){
        let affiliateViewData = new AffiliateViewDataModel();
        let affiliateCode = new TrackingCookie(AFFILIATE_COOKIE_NAME).get();
        if(affiliateCode){
            const parts = affiliateCode.split('-');
            const userId = parseInt(parts[0]);
            const urlId = parseInt(parts[1]);

            let sameAffiliate = false;
            let expiredAffiliateViewData = true;
            if(store.state.affiliateViewData){
                sameAffiliate = store.state.affiliateViewData.user_id === userId;
                expiredAffiliateViewData = Date.now() - store.state.affiliateViewData.timestamp > 3600000
            }

            if(!sameAffiliate || expiredAffiliateViewData){
                this.getAffiliateSettings(userId).then((response: any) => {
                    affiliateViewData = response.data;
                    affiliateViewData.timestamp = Date.now();
                    store.dispatch('storeAffiliateViewData', affiliateViewData)
                })
            }

        }
    }

    public async addUrl(urlData: any){
        if(store.state.indieLogin){
            const configuration = await this.getConfiguration();
            urlData['url-data'].id = this.generateUrlId(configuration.data.urls);
            return this.httpClient.post('/affiliate-configuration/add-url', urlData);
        }
    }

    public generateUrlId(urls: Array<any>): number{
        let maxUrlId = 0;
        urls.forEach((url: any) => {
            if (maxUrlId < url.id) {
                maxUrlId = url.id;
            }
        })
        return maxUrlId > 0 ? maxUrlId + 7 : Math.floor(Math.random() * Math.floor(9999))
    }

    public static makeAffiliateUrl(urlString: string, userId: number, urlId: number) {
        return urlString + '/ac/' + userId + '-' + urlId;
    }


}
